import { publicQuoteDate } from './publicQuoteDate';
import { Box, Paper, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { publicQuoteOverview } from '@bandido/shared/commercial-quotes';
import type { PublicQuoteSnapshot, PublicQuoteSelection } from '@bandido/shared/types';
export function PublicQuoteOverview({
  snapshot,
  selection,
}: {
  snapshot: PublicQuoteSnapshot;
  selection: PublicQuoteSelection;
}) {
  const { t, i18n } = useTranslation();
  const tr = (key: string) => t(`commercialQuotes.customerText.${key}`);
  const overview = publicQuoteOverview(snapshot, selection);
  const date = (value: string) => publicQuoteDate(value, i18n.language);
  return (
    <Stack spacing={2} sx={{ mb: 3 }}>
      {overview.startDate && (
        <Typography fontWeight={600}>
          {date(overview.startDate)}
          {overview.endDate && overview.endDate !== overview.startDate ? ` → ${date(overview.endDate)}` : ''}
        </Typography>
      )}
      {snapshot.advisorName && (
        <Typography>
          {tr('advisor')}: {snapshot.advisorName}
        </Typography>
      )}
      {snapshot.introduction?.trim() && (
        <Typography sx={{ whiteSpace: 'pre-line', overflowWrap: 'anywhere' }}>{snapshot.introduction}</Typography>
      )}
      {!!overview.services.length && (
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
          <Typography fontWeight={700}>{tr('includes')}</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 0 }}>
            {overview.services.map((service) => (
              <Box component="li" key={service.id} sx={{ py: 0.5, overflowWrap: 'anywhere' }}>
                {service.title}
              </Box>
            ))}
          </Box>
        </Paper>
      )}
    </Stack>
  );
}
